export const LOADING_STATES: {
  [loadingState: string]: { emoji: string };
} = {
  '0': {
    emoji: '🌕'
  },
  '10': {
    emoji: '🌖'
  },
  '20': {
    emoji: '🌗'
  },
  '30': {
    emoji: '🌘'
  },
  '40': {
    emoji: '🌘'
  },
  '50': {
    emoji: '🌑'
  },
  '60': {
    emoji: '🌒'
  },
  '70': {
    emoji: '🌓'
  },
  '80': {
    emoji: '🌓'
  },
  '90': {
    emoji: '🌔'
  },
  '100': {
    emoji: '🌕'
  }
};
